export default __webpack_public_path__ + "e6ae45dcf72eb73c2ca1851fd44b177a.jpg";